import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ChevronDownIcon } from 'lucide-react';
import Moment from 'moment-timezone';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Badge } from 'twyne-new.ui'

import appStore from 'stores/app'

const propTypes = {
  onChange: PropTypes.func,
  color: PropTypes.string,
  outline: PropTypes.bool,
  className: PropTypes.string,
  dates: PropTypes.object
};

const tz = () => Moment.tz(appStore.timezone)

const option = (name, start, end) => ({
  name,
  get start() { return start() },
  get end() { return end() }
})

const DateRangeOptions = [
  option('Today', () => tz().startOf('day'), () => tz().endOf('day')),
  option('Yesterday', () => tz().startOf('day').subtract(1, 'days'), () => tz().endOf('day').subtract(1, 'days')),
  option('Last 7 days', () => tz().startOf('day').subtract(1, 'weeks'), () => tz().endOf('day')),
  option('Last 30 days', () => tz().startOf('day').subtract(1, 'months'), () => tz().endOf('day')),
  option('Month to date', () => tz().startOf('month'), () => tz().endOf('day')),
  option('Last month', () => tz().startOf('month').subtract(1, 'months'), () => tz().startOf('month').subtract(1, 'months').endOf('month'))
]

const getRangeName = ({ startDate, endDate }) => {
  startDate = startDate ? startDate.format('MM-DD-YYYYTHH:mm:ss') : null;
  endDate = endDate ? endDate.format('MM-DD-YYYYTHH:mm:ss') : null;

  for (let opt of DateRangeOptions) {
    if ( startDate === opt.start.format('MM-DD-YYYYTHH:mm:ss') && endDate === opt.end.format('MM-DD-YYYYTHH:mm:ss') ) {
      return opt.name;
    }
  }

  return 'Select date range';
}

class DateRangeButton extends Component {
  state = {
    open: false
  }

  toggle = () => {
    this.setState({ open: !this.state.open });
  }
  
  handleClick = (start, end) => {
    if (this.props.onChange) {
      this.props.onChange({ startDate: start, endDate: end });
    }
  }

  render() {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Badge size='lg' className={`self-center ${this.props.className}`} color={this.props.color || 'accent'} variant={this.props.variant || 'default'}>
            {getRangeName(this.props.dates ? this.props.dates : {})}
            <ChevronDownIcon size={12} />
          </Badge>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {DateRangeOptions.map((option, index) => <>
            <DropdownMenuItem
              key={index}
              onClick={() => this.handleClick(option.start, option.end)}
            >
              {option.name}
            </DropdownMenuItem>
          </>)}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
}

DateRangeButton.propTypes = propTypes;

export default DateRangeButton;
const [
  TODAY,
  YESTERDAY,
  LASTWEEK,
  LASTMONTH,
  MONTHTODATE,
  PASTMONTH,
] = DateRangeOptions

export {
  TODAY,
  YESTERDAY,
  LASTWEEK,
  LASTMONTH,
  MONTHTODATE,
  PASTMONTH
}